<div class="jumbotron">
    <h1 class="display-4">Como anunciar!</h1>
    <p class="lead">Criar um layout para que possa receber anexos em PDF, sobre o assunto</p>
</div>